
import { debounceTime } from 'rxjs/operators'
import { useEffect, useRef, useState } from 'react'
import { Subject } from 'rxjs'


export function useDebounce<T>(delay: number, initialValue: T, callback: (param: T) => void): [T, (args: T) => void] {
  const [value, setValue] = useState<T>(initialValue)
  const subject$ = useRef<Subject<T>>(undefined)

  useEffect(() => {
    subject$.current = new Subject()
    subject$.current.pipe(debounceTime(delay)).subscribe(callback)

    return () => {
      if (subject$.current) {
        subject$.current.unsubscribe()
      }
    }
    // EXPL: generic debounce pipeline set up once on mount. `callback` is recreated by callers on
    // every render and `delay` is captured at init — listing them would recreate the subject each
    // render and break debouncing. The hook intentionally binds the initial callback/delay.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (value !== null && subject$.current) {
      subject$.current.next(value)
    }
  }, [value])

  return [value, setValue]
}
